import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Legacy redirect: the standalone Installations (node) list page has been
 * decommissioned in favour of the unified Agents fleet (CLA-418), which merges
 * account and node health into one row per agent. Kept so external links and
 * bookmarks continue to land on the right page.
 *
 * @since 1.0.0
 */
export const Route = createFileRoute("/clawinstall/admin/installations/")({
  beforeLoad: () => {
    throw redirect({ to: "/clawinstall/admin/agents" });
  },
});
